import React from 'react'
import './portfolio.css'
import servicebg from '../../../assets/package.jpg'
import Footer from '../Footer/Footer'

// Reusing images from services page
import offshoreRigImg from '../../../assets/architecture.jpg'
import drillingPlatformImg from '../../../assets/52381.jpg'
import structuralEnhancementsImg from '../../../assets/10664.jpg'
import enhancementsImg from '../../../assets/19366.jpg'
import pipelineImg from '../../../assets/2080.jpg'
import naturalGasImg from '../../../assets/2149057713.jpg'

const Portfolio = () => {
    return (
        <>
            <div className="portfolio-container">
                <div className='portfolio-image'>
                    <img src={servicebg} alt="Energy portfolio background" />
                    <div className='portfolio-overlay'></div>
                </div>

                <div className="text">
                    <h1>Our Portfolio</h1>
                    <div 
                        data-aos="fade-right"
                        data-aos-easing="linear"
                        data-aos-duration="1000"
                        className="block">
                    </div>
                </div>
            </div>

            <div className="portfolio-intro">
                <div className="intro-content">
                    <p>
                        At  Helix Energy Solutions, we take pride in our diverse portfolio of energy projects 
                        that span across offshore operations, sustainable energy solutions, and cutting-edge 
                        technology implementations. Our projects showcase our commitment to innovation, 
                        sustainability, and excellence in the energy sector. Below are some of our flagship 
                        projects that demonstrate our expertise and dedication to transforming the energy 
                        landscape globally.
                    </p>
                </div>
            </div>

            <div className="portfolio-categories">
                <div className="category-header">
                    <h2>Project Categories</h2>
                    <p>
                        Our portfolio spans across various segments of the energy sector, showcasing our versatility 
                        and expertise in delivering comprehensive energy solutions.
                    </p>
                </div>
                
                <div className="category-pillars">
                    <div className="pillar">
                        <h3>Offshore Operations</h3>
                        <p>
                            Our offshore projects demonstrate our leadership in 
                            deep-water drilling, platform construction, and 
                            marine energy extraction, setting industry standards 
                            for safety and efficiency.
                        </p>
                    </div>
                    
                    <div className="pillar">
                        <h3>Renewable Energy</h3>
                        <p>
                            We are pioneering renewable energy solutions through 
                            innovative offshore wind farms, solar installations, 
                            and sustainable energy storage systems that contribute 
                            to a low-carbon future.
                        </p>
                    </div>
                    
                    <div className="pillar">
                        <h3>Infrastructure Development</h3>
                        <p>
                            Our infrastructure projects include pipeline networks, 
                            processing facilities, and distribution systems that 
                            ensure reliable energy delivery while minimizing 
                            environmental impact.
                        </p>
                    </div>
                </div>
            </div>

            <div className="portfolio-cards">
                <h2>Featured Projects</h2>
                <p>
                    Explore our most significant projects that showcase our technical expertise, 
                    innovation capabilities, and commitment to sustainable energy solutions.
                </p>
                
                <div className="cards-grid">
                    <div className="cards-content">
                        <div className="image">
                            <img src={offshoreRigImg} alt="North Sea Wind Farm" />
                        </div>
                        <div className="text">
                            <h3>North Sea Wind Farm</h3>
                            <p>
                                A cutting-edge offshore wind installation featuring 
                                80 wind turbines with a total capacity of 400 MW, 
                                providing clean energy to over 300,000 homes across 
                                Northern Europe.
                            </p>
                            <div className="project-details">
                                <span>Completed: 2023</span>
                            </div>
                        </div>
                    </div>
                    
                    <div className="cards-content">
                        <div className="image">
                            <img src={drillingPlatformImg} alt="Mexico Deep Water Drill" />
                        </div>
                        <div className="text">
                            <h3>Mexico Deep Water Drill</h3>
                            <p>
                                A state-of-the-art deep water drilling platform 
                                utilizing advanced technology to reduce carbon 
                                footprint while maximizing resource extraction 
                                efficiency.
                            </p>
                            <div className="project-details">
                                <span>Completed: 2019</span>
                            </div>
                        </div>
                    </div>
                    
                    <div className="cards-content">
                        <div className="image">
                            <img src={structuralEnhancementsImg} alt="Arctic Circle Facility" />
                        </div>
                        <div className="text">
                            <h3>Arctic Circle Facility</h3>
                            <p>
                                A pioneering production facility designed to 
                                withstand extreme arctic conditions while maintaining 
                                the highest environmental and safety standards.
                            </p>
                            <div className="project-details">
                                <span>Completed: 2015</span>
                            </div>
                        </div>
                    </div>
                    
                    <div className="cards-content">
                        <div className="image">
                            <img src={pipelineImg} alt="Trans-Continental Pipeline Network" />
                        </div>
                        <div className="text">
                            <h3>Trans-Continental Pipeline Network</h3>
                            <p>
                                A 1,500 km pipeline network featuring advanced 
                                monitoring systems and protective measures to 
                                ensure safe and efficient energy transport across 
                                diverse terrains.
                            </p>
                            <div className="project-details">
                                <span>Completed: 2010</span>
                            </div>
                        </div>
                    </div>
                    
                    <div className="cards-content">
                        <div className="image">
                            <img src={naturalGasImg} alt="Mediterranean LNG Terminal" />
                        </div>
                        <div className="text">
                            <h3>Mediterranean LNG Terminal</h3>
                            <p>
                                A cutting-edge LNG processing and distribution 
                                terminal that provides clean natural gas to 
                                Southern European markets, reducing regional 
                                dependency on coal power.
                            </p>
                            <div className="project-details">
                                <span>Completed: 2006</span>
                            </div>
                        </div>
                    </div>
                    
                    <div className="cards-content">
                        <div className="image">
                            <img src={enhancementsImg} alt="Carbon Capture Facility" />
                        </div>
                        <div className="text">
                            <h3>Carbon Capture Facility</h3>
                            <p>
                                An innovative carbon capture and storage facility 
                                designed to sequester up to 1.5 million tons of CO2 
                                annually, demonstrating our commitment to 
                                reducing emissions.
                            </p>
                            <div className="project-details">
                                <span>Completed: 2002</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="project-achievements">
                <div className="achievements-content">
                    <h2>Our Project Achievements</h2>
                    <p>
                        Throughout our project history,  Helix Energy Solutions has consistently delivered 
                        excellence across various metrics. Our projects have not only met but exceeded 
                        industry standards, earning recognition and setting new benchmarks in the energy 
                        sector. Below are some key achievements across our portfolio:
                    </p>
                    
                    <div className="achievements-stats">
                        <div className="stat-item">
                            <h3>150+</h3>
                            <p>Projects Completed</p>
                        </div>
                        <div className="stat-item">
                            <h3>25</h3>
                            <p>Countries Served</p>
                        </div>
                        <div className="stat-item">
                            <h3>30%</h3>
                            <p>Average Carbon Reduction</p>
                        </div>
                        <div className="stat-item">
                            <h3>$12B</h3>
                            <p>Total Project Value</p>
                        </div>
                    </div>
                </div>
                <div className="achievements-logo">
                    <img src={naturalGasImg} alt=" Helix Energy Solutions Logo" />
                </div>
            </div>
   
            <Footer />
        </>
    )
}

export default Portfolio